import gql from 'graphql-tag';

const BLOG_CATEGORIES_QUERY = gql`
    query Categories {
        blogCategories (sort: "title:asc") {
            id
            title,
            blog_entries {
                id,
                title
            }
        }
    }
`;

export default BLOG_CATEGORIES_QUERY;
